export const langUserForm = {
    "arm": {
        tr_confirm: "Հաստատել",
        tr_insertPhoto: "Տեղադրել նկար",
        tr_removePhoto: "Ջնջել նկարը",
        tr_name: "Անուն",
        tr_surname: "Ազգանուն",
        tr_patronymic: "Հայրանունը",
        tr_residenc: "Բնակավայր",
        tr_workplace: "Աշխատավայր",
        tr_telephone: "Հեռախոս",
        tr_position: "Պաշտոնը",
        tr_email: "Էլ․ փոստ",
        tr_image: "Նկար",
        tr_nickname: "Մականուն",
        tr_nicknameHint: "Ընկերները կկարողանան գտնել Ձեզ այս մականունով",
        errors: {
            PHONE_TAKEN: "Այս հեռախոսահամարով օգտատեր արդեն գրանցված է",
            NICKNAME_INVALID: "Մականունը պետք է լինի 3-20 լատինատառ սիմվոլ, թվեր, \".\" կամ \"_\"",
            NICKNAME_TAKEN: "Այս մականունն արդեն զբաղված է",
        }
        
    },
    "eng": {
        tr_confirm: "Confirm",
        tr_insertPhoto: "Insert photo/picture",
        tr_removePhoto: "Remove photo/picture",
        tr_name: "Name",
        tr_surname: "Surname",
        tr_patronymic: "Patronymic",
        tr_residenc: "Residenc",
        tr_workplace: "Workplace",
        tr_telephone: "Telephone",
        tr_position: "Position",
        tr_email: "E-mail",
        tr_image: "Image",
        tr_nickname: "Nickname",
        tr_nicknameHint: "Friends will be able to find you by this nickname",
        errors: {
            PHONE_TAKEN: "This phone number is already registered",
            NICKNAME_INVALID: "Nickname must be 3-20 latin letters, digits, \".\" or \"_\"",
            NICKNAME_TAKEN: "This nickname is already taken",
        }
    },
    "fr": {
        tr_confirm: "Approuver",
        tr_insertPhoto: "Insérer une photo/image",
        tr_removePhoto: "Supprimer la photo/l’image",
        tr_name: "Nom",
        tr_surname: "Nom de famille",
        tr_patronymic: "Nom du père",
        tr_residenc: "Résidence",
        tr_workplace: "Lieu de travail",
        tr_telephone: "Téléphone",
        tr_position: "Position",
        tr_email: "E-mail",
        tr_image: "Image",
        tr_nickname: "Pseudo",
        tr_nicknameHint: "Vos amis pourront vous trouver avec ce pseudo",
        errors: {
            PHONE_TAKEN: "Ce numéro de téléphone est déjà enregistré",
            NICKNAME_INVALID: "Le pseudo doit contenir 3 à 20 lettres latines, chiffres, \".\" ou \"_\"",
            NICKNAME_TAKEN: "Ce pseudo est déjà pris",
        }
    },
    "arb": {
        tr_confirm: "تأكيد",
        tr_insertPhoto: "إدخال صورة",
        tr_removePhoto: "حذف الصورة",
        tr_name: "اسم",
        tr_surname: "اسم العائلة",
        tr_patronymic: "اسم الأب",
        tr_residenc: "مسكن",
        tr_workplace: "مكان العمل",
        tr_telephone: "هاتف",
        tr_position: "موضع",
        tr_email: "بريد إلكتروني",
        tr_image: "صورة",
        tr_nickname: "الاسم المستعار",
        tr_nicknameHint: "سيتمكن الأصدقاء من العثور عليك بهذا الاسم المستعار",
        errors: {
            PHONE_TAKEN: "رقم الهاتف هذا مسجل بالفعل",
            NICKNAME_INVALID: "يجب أن يتكون الاسم المستعار من 3 إلى 20 حرفًا لاتينيًا أو أرقامًا أو \".\" أو \"_\"",
            NICKNAME_TAKEN: "هذا الاسم المستعار مستخدم بالفعل",
        }
    },
    "rus": {
        tr_confirm: "Подтвердить",
        tr_insertPhoto: "Загрузить фото",
        tr_removePhoto: "Удалить фото",
        tr_name: "Имя",
        tr_surname: "Фамилия",
        tr_patronymic: "Отчество",
        tr_residenc: "Место жительства",
        tr_workplace: "Место работы",
        tr_telephone: "Телефон",
        tr_position: "Должность",
        tr_email: "Эл. почта",
        tr_image: "Фото",
        tr_nickname: "Никнейм",
        tr_nicknameHint: "Друзья смогут найти вас по этому никнейму",
        errors: {
            PHONE_TAKEN: "Этот номер телефона уже зарегистрирован",
            NICKNAME_INVALID: "Никнейм должен содержать 3–20 латинских букв, цифр, \".\" или \"_\"",
            NICKNAME_TAKEN: "Этот никнейм уже занят",
        },
    }
}